import { useCallback } from 'react';
import { api } from 'src/constants/apiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

export interface InvoicePoAssignmentRequest {
  invoiceId?: number;
  poId?: number;
  useSinglePeriod?: boolean;
  copyInvoiceAllocations?: boolean;
}

const useInvoicePoAssignmentApi = () => {
  const call = useCallback(async (body?: InvoicePoAssignmentRequest) => {
    try {
      const res = await axiosInstance.put<number>(
        api.changeInvoicePoAssignment(body?.invoiceId),
        body
      );
      return res?.data as number;
    } catch (error) {
      throw new Error(error);
    }
  }, []);

  const { execute, isLoading } = useAsync(call, false);

  return {
    isLoading,
    changeInvoicePoAssignment: execute,
  };
};

export default useInvoicePoAssignmentApi;
